import PaintBase from "./PaintBase";

import { FillPaint, SymbolPaint, SymbolLayout } from "mapbox-gl";
import { ColorScale } from "./PaintStore";

export default class GemeentePaint extends PaintBase {
  constructor() {
    super();
    this.view = "gemeente";
  }

  fillPaint(colorScale: ColorScale, property: string): FillPaint | undefined {
    let colorSteps = ["#fff", ...colorScale];
    return {
      "fill-outline-color": ["case", ["boolean", ["feature-state", "hover"], false], "green", "#333"],
      "fill-antialias": true,
      "fill-opacity": ["case", ["==", ["get", "count"], 0], 0.2, ["==", ["feature-state", "hover"], true], 1, 0.6],
      "fill-color": ["step", ["get", property], ...colorSteps]
    };
  }

  symbolPaint(colorScale: ColorScale, property: string): SymbolPaint | undefined {
    return {
      "text-opacity": ["match", ["get", property], 0, 0, 1]
    };
  }

  symbolLayout(colorScale: ColorScale, property: string): SymbolLayout | undefined {
    return {
      "text-anchor": "center",
      "text-field": ["get", property],
      "text-size": ["interpolate", ["linear"], ["zoom"], 8, 0, 13, 100, 22, 150]
    };
  }
}
